import { useContext } from "react";
import { useLocation } from "react-router-dom";
import { Sun, Moon, LogOut } from "lucide-react";
import { ThemeContext } from "../context/ThemeContext";
import { AuthContext }  from "../context/AuthContext";
import Avatar from "../modules/components/ui/Avatar";
import LogoutDialog from "./LogoutDialog";
import { useState } from "react";

const PAGE_TITLES = {
  dashboard:     "Dashboard",
  campaigns:     "Campaigns",
  automations:   "Automations",
  contacts:      "Contacts",
  templates:     "Templates",
  segments:      "Segments",
  analytics:     "Analytics",
  settings:      "Settings",
  "your-account":  "Your Account",
  "login-security": "Login & Security",
};

export default function Header() {
  const { theme, toggleTheme } = useContext(ThemeContext);
  const { user }               = useContext(AuthContext);
  const location               = useLocation();
  const [logoutOpen, setLogoutOpen] = useState(false);

  const segment   = location.pathname.split("/").filter(Boolean).pop();
  const pageTitle = PAGE_TITLES[segment] ?? "SwiftReach";

  return (
    <>
      <header className="flex items-center gap-4 px-6 py-3.5 border-b border-border bg-surface/80 backdrop-blur-sm sticky top-0 z-20">
        <div className="flex-1">
          <h1 className="text-base font-semibold text-text_primary">{pageTitle}</h1>
        </div>

        <div className="flex items-center gap-2">
          <button
            onClick={toggleTheme}
            className="w-9 h-9 rounded-lg flex items-center justify-center border border-border text-text_muted hover:bg-surface_alt hover:text-text_primary transition-colors"
          >
            {theme === "dark" ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
          </button>

          <button
            onClick={() => setLogoutOpen(true)}
            className="w-9 h-9 rounded-lg flex items-center justify-center border border-border text-text_muted hover:bg-danger_bg hover:text-danger transition-colors"
          >
            <LogOut className="w-4 h-4" />
          </button>

          <div className="flex-shrink-0">
            <Avatar user={user} size={34} />
          </div>
        </div>
      </header>

      <LogoutDialog open={logoutOpen} onClose={() => setLogoutOpen(false)} />
    </>
  );
}
